import { Link } from 'react-router-dom';
import { useContext } from 'react';
import { ModalContext } from '../App';

const Header = () => {
  const { setIsModalOpen } = useContext(ModalContext);

  const handleGetStarted = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  return (
    <header className="bg-white shadow-md">
      <nav className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="text-2xl font-bold text-gray-800">
            Civic Guru
          </Link>
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-600 hover:text-gray-900">Home</Link>
            <Link to="/about" className="text-gray-600 hover:text-gray-900">About</Link>
            <Link to="/faq" className="text-gray-600 hover:text-gray-900">FAQ</Link>
            <Link to="/blog" className="text-gray-600 hover:text-gray-900">Blog</Link>
          </div>
          <Link 
            to="/"
            onClick={handleGetStarted}
            className="bg-blue-600 text-white px-6 py-2 rounded-full hover:bg-blue-700 transition-colors"
          >
            Get Started
          </Link>
        </div>
      </nav>
    </header>
  );
};

export default Header; 